import useLockerCode from './useLockerCode';

export default useLockerCode;
